// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nkl-layout-footer {\n  display: flex;\n  align-items: center;\n  padding: 24px !important;\n  background: white !important;\n  border-top: 1px solid #e6e6e6;\n}\n.nkl-layout-footer .copyright {\n  font-size: 12px;\n  margin-right: auto;\n}\n.card-footer-pointer {\n  cursor: pointer;\n}\n@media only screen and (max-width: 640px) {\n  .hide-for-moobile {\n    display: block;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
